import { render, staticRenderFns } from "./DataListVehicule_rejete.vue?vue&type=template&id=601cb696&scoped=true&"
import script from "./DataListVehicule_rejete.vue?vue&type=script&lang=js&"
export * from "./DataListVehicule_rejete.vue?vue&type=script&lang=js&"
import style0 from "./DataListVehicule_rejete.vue?vue&type=style&index=0&id=601cb696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601cb696",
  null
  
)

export default component.exports